
import ua from 'universal-analytics'

const analytics = ua('UA-137873567-1');

export default analytics


// WEBPACK FOOTER //
// ./src/utils/analytics.js